module.exports = __webpack_public_path__ + "static/img/inner_bg.png";